import { MapPin } from "lucide-react";
import { Box, TextField } from "./fields";

// Campos do topo que a EKKO tem a mais: etiqueta (localização), descrição da foto e assinatura da marca
export default function HeroExtrasEditor({ content, setContent }) {
  return (
    <Box title="Topo: etiqueta, foto e assinatura" icon={MapPin}>
      <TextField label="Etiqueta verde por cima do título" field="hero_badge" content={content} setContent={setContent} />
      <TextField label="Descrição da foto do topo (para quem não a vê e para o Google)" field="hero_image_alt" content={content} setContent={setContent} />
      <TextField label="Assinatura por baixo do logótipo" field="brand_tagline" content={content} setContent={setContent} />
    </Box>
  );
}
